import React, { useState } from "react";
import { classNames } from 'primereact/utils'; 

const CashFlow = (props) => {
    const parentData = props;
  const [expandedAssets, setExpandedAssets] = useState({});


    const toggleAssetCategory = (index) => {
        setExpandedAssets((prevState) => ({
          ...prevState,
          [index]: !prevState[index], 
        }));
      };
  return (
    <div
    style={{
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <div className="card card-borderless py-2" style={{ width: "100%", padding: "0 10px" }}>
      <div className="d-flex justify-content-between p-2" style={{ backgroundColor: "#EAF2E3" }}>
        <strong className="m-0 d-inline-flex">Particular</strong>
        <strong className="m-0 d-inline-flex">Amount ({parentData.currency})</strong>
      </div>
      <table className="mb-4" style={{ width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "transparent" }}>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {parentData.cashFlow.map((type, i) => (
              <React.Fragment key={i}>
                <tr
                  style={{ border: "1px solid rgb(224 224 224)", cursor:"pointer", fontWeight: "bold" }}
                  onClick={() => toggleAssetCategory(i)}
                >
                  <td style={{ border: "none" }}>
                    <span className="d-flex align-items-center fw-bold">
                      {type.accountName}
                      {Array.isArray(type.tax) && (
                        <i
                          className={classNames(
                            'pi',
                            expandedAssets[i] ? 'pi-angle-down' : 'pi-angle-right',
                            'ms-2'
                          )}
                        ></i>
                      )}
                    </span>
                  </td>
                  <td
                    className="text-end fw-bold"
                    style={{
                      color: type?.amount < 0 ? "red" : "inherit", border:"none"
                    }}
                  >
                    {type?.amount?.toFixed(2)}
                  </td>
                </tr>

                {expandedAssets[i] &&
                  
                  type.tax.map((item, k) => (
                    <tr key={k} style={{ border: "1px solid rgb(224 224 224)" }}>
                      <td className="ps-3">{item.taxName}</td>
                      <td
                        className="text-end pe-4"
                        style={{
                          color: item.taxAmount < 0 ? "red" : "inherit",
                          border: "none",
                        }}
                      >
                        {item?.taxAmount?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>

  </div>
  )
}

export default CashFlow